import { lazy } from 'react'
import { DndProvider } from 'react-dnd'
import mixpanel from 'mixpanel-browser'
import { useSelector } from 'react-redux'
import { RootState } from './store/store'
import ProtectedRoute from './utils/ProtectedRoute'
import { HTML5Backend } from 'react-dnd-html5-backend'
import PageLoader from './components/shared/PageLoader'
import { GoogleOAuthProvider } from '@react-oauth/google'
import GameNotFound from './components/shared/GameNotFound'
import MyGames from './pages/dashboard/my-games/MyGames'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import DisplayTutorial from './components/shared/DisplayTutorial'
import LeaderBoard from './pages/dashboard/leaderboard/Leaderboard'

const Login = lazy(() => import('./pages/auth/Login'))
const GameEditor = lazy(() => import('./pages/edit/GameEditor'))
const Preview = lazy(() => import('./pages/edit/components/Preview'))
const MagicLinkValidate = lazy(() => import('./pages/auth/MagicLinkValidate'))

// Initialize Mixpanel
const MIAPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN
const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_AUTH_URL

if (!MIAPANEL_TOKEN) {
  console.error('VITE_MIXPANEL_TOKEN= is not defined in environment')
}
mixpanel.init(MIAPANEL_TOKEN, {
  api_host: 'https://info.braincade.in/',
  debug: false,
  track_pageview: true,
  persistence: 'localStorage',
})

const App = () => {
  const displayTutorial = useSelector(
    (state: RootState) => state.tutorial.displayTutorial
  )
  const previewMode = useSelector(
    (state: RootState) => state.system.previewMode
  )

  return (
    <DndProvider backend={HTML5Backend}>
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <BrowserRouter
          basename="/"
          future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
        >
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route
                path="/"
                element={
                  <PageLoader>
                    <GameEditor />
                  </PageLoader>
                }
              >
                <Route
                  path="/:id"
                  element={
                    <PageLoader>
                      <GameEditor />
                    </PageLoader>
                  }
                />
              </Route>
              <Route
                path="/dashboard/my-games"
                element={
                  <PageLoader>
                    <MyGames />
                  </PageLoader>
                }
              />
              <Route
                path="/dashboard/leaderboard"
                element={
                  <PageLoader>
                    <LeaderBoard />
                  </PageLoader>
                }
              />
            </Route>
            <Route
              path="/login"
              element={
                <PageLoader>
                  <Login />
                </PageLoader>
              }
            />
            <Route
              path="/validate"
              element={
                <PageLoader>
                  <MagicLinkValidate />
                </PageLoader>
              }
            />
            <Route
              path="*"
              element={
                <PageLoader>
                  <GameNotFound />
                </PageLoader>
              }
            />
          </Routes>
        </BrowserRouter>
        {previewMode && <Preview />}
        {displayTutorial && <DisplayTutorial />}
      </GoogleOAuthProvider>
    </DndProvider>
  )
}

export default App
